import { useCallback, useEffect, useState } from "react";
import { api, unwrapCollection } from "../utils/api";

export function useConnections(userId, { autoLoad = true } = {}) {
  const [connections, setConnections] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  const loadConnections = useCallback(async () => {
    if (!userId) {
      setConnections([]);
      setIsLoaded(true);
      return [];
    }

    try {
      setError(null);
      const result = await api.get(`/connections?anyUserID=${userId}`);
      const nextConnections = unwrapCollection(result);
      setConnections(nextConnections);
      setIsLoaded(true);
      return nextConnections;
    } catch (nextError) {
      setError(nextError);
      setIsLoaded(true);
      return [];
    }
  }, [userId]);

  useEffect(() => {
    if (autoLoad) {
      loadConnections();
    }
  }, [autoLoad, loadConnections]);

  return {
    connections,
    error,
    isLoaded,
    loadConnections,
    setConnections,
  };
}
